module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/vyuIVf/images/cover.jpg?1684979201298",
      "alt": "This image is the cover for the book Redeeming Transcendence in the Arts"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Redeeming Transcendence in the Arts\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('i', [_vm._v("How can the arts witness to the transcendence of the Christian God?")])]), _c('p', [_vm._v("Many people believe that there is something transcendent about the arts, that they can awaken a profound sense of awe, wonder, and mystery, of something “beyond” this world—even for those who may have no use for conventional forms of Christianity. In this book Jeremy Begbie—a leading voice on theology and the arts—employs a biblical, Trinitarian imagination to show how Christian involvement in the arts can be shaped by the distinctive vision of God’s transcendence opened up in and through Jesus Christ.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jeremy Begbie\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Jeremy S. Begbie is Thomas A. Langford Research Professor of Theology at Duke Divinity School and senior member at Wolfson College, Cambridge. His other books include Resounding Truth: Christian Wisdom in the World of Music.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    William B. Eerdmans Publishing Company\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0